webpackJsonp([30],{

/***/ 135:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_html5_editor__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_html5_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_html5_editor__);


/* harmony default export */ __webpack_exports__["a"] = (function () {
  var opt = {
    // 全局组件名称，使用new VueHtml5Editor(options)时该选项无效
    name: "vue-html5-editor",
    // 是否显示模块名称，开启的话会在工具栏的图标后台直接显示名称
    showModuleName: true,
    // 自定义各个图标的class，默认使用的是font-awesome提供的图标
    icons: {
      text: "fa fa-pencil",
      color: "fa fa-paint-brush",
      font: "fa fa-font",
      align: "fa fa-align-justify",
      list: "fa fa-list",
      link: "fa fa-chain",
      unlink: "fa fa-chain-broken",
      tabulation: "fa fa-table",
      image: "fa fa-file-image-o",
      hr: "fa fa-minus",
      eraser: "fa fa-eraser",
      undo: "fa-undo fa",
      "full-screen": "fa fa-arrows-alt",
      info: "fa fa-info"
    },
    // 配置图片模块
    image: {
      // 文件最大体积，单位字节
      sizeLimit: 512 * 1024 * 10,
      // 上传参数,默认把图片转为base64而不上传
      // upload config,default null and convert image to base64
      upload: {
        url: null,
        headers: {},
        params: {},
        fieldName: {}
      },
      // 压缩参数,默认使用localResizeIMG进行压缩,设置为null禁止压缩
      // width和height是文件的最大宽高
      compress: {
        width: 600,
        height: 600,
        quality: 80
      },
      // 响应数据处理,最终返回图片链接
      uploadHandler: function uploadHandler(responseText) {
        //default accept json data like  {ok:false,msg:"unexpected"} or {ok:true,data:"image url"}
        var json = JSON.parse(responseText);
        console.info(json);
        if (!json.ok) {
          alert(json.msg);
        } else {
          return json.data;
        }
      }
    },
    // 语言，内建的有英文（en-us）和中文（zh-cn）
    language: "zh-cn",
    // 自定义语言
    i18n: {
      "zh-cn": {
        "align": "对齐方式",
        "image": "图片",
        "list": "列表",
        "link": "链接",
        "unlink": "去除链接",
        "table": "表格",
        "font": "文字",
        "full screen": "全屏",
        "text": "排版",
        "eraser": "格式清除",
        "info": "关于",
        "color": "颜色",
        "please enter a url": "请输入地址",
        "create link": "创建链接",
        "bold": "加粗",
        "italic": "倾斜",
        "underline": "下划线",
        "strike through": "删除线",
        "subscript": "上标",
        "superscript": "下标",
        "heading": "标题",
        "font name": "字体",
        "font size": "文字大小",
        "left justify": "左对齐",
        "center justify": "居中",
        "right justify": "右对齐",
        "ordered list": "有序列表",
        "unordered list": "无序列表",
        "fore color": "前景色",
        "background color": "背景色",
        "row count": "行数",
        "column count": "列数",
        "save": "确定",
        "upload": "上传",
        "progress": "进度",
        "unknown": "未知",
        "please wait": "请稍等",
        "error": "错误",
        "abort": "中断",
        "reset": "重置"
      }
    },
    // 隐藏不想要显示出来的模块
    hiddenModules: [],
    // 自定义要显示的模块，并控制顺序
    visibleModules: [
    // "text",
    "color", "font",
    // "align",
    // "list",
    "link",
    // "unlink",
    // "tabulation",
    "image"],
    // 扩展模块，具体可以参考examples或查看源码
    // extended modules
    modules: {
      //omit,reference to source code of build-in modules
    }
  };
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_html5_editor___default.a, opt);
});

/***/ }),

/***/ 136:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_store__ = __webpack_require__(69);




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var Home = function Home() {
  return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 375));
};
var MatchDetail = function MatchDetail() {
  return __webpack_require__.e/* import() */(23).then(__webpack_require__.bind(null, 378));
};
var FindDetail = function FindDetail() {
  return __webpack_require__.e/* import() */(19).then(__webpack_require__.bind(null, 371));
};
var Equip = function Equip() {
  return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 368));
};
var EquipList = function EquipList() {
  return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 370));
};
var EquipDetail = function EquipDetail() {
  return __webpack_require__.e/* import() */(26).then(__webpack_require__.bind(null, 369));
};
var Collect = function Collect() {
  return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 365));
};
var CollectText = function CollectText() {
  return __webpack_require__.e/* import() */(28).then(__webpack_require__.bind(null, 366));
};
var SignUp = function SignUp() {
  return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, 389));
};
var AddSignup = function AddSignup() {
  return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, 364));
};
var SignupList = function SignupList() {
  return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 390));
};
var Pay = function Pay() {
  return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 383));
};
// const News = () => import('@/pages/news/news.vue')
// const Detail = () => import('@/pages/detail/detail.vue')
var Login = function Login() {
  return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 376));
};
var Forgot = function Forgot() {
  return __webpack_require__.e/* import() */(18).then(__webpack_require__.bind(null, 373));
};
// const LoginNext = () => import('@/pages/loginNext/loginNext.vue')
var SetPwd = function SetPwd() {
  return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, 388));
};
var Deal = function Deal() {
  return __webpack_require__.e/* import() */(27).then(__webpack_require__.bind(null, 367));
};
var Register = function Register() {
  return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 386));
};

var Match = function Match() {
  return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 377));
};

// const Analysis = () => import('@/pages/analysis/analysis.vue')
// const Score = () => import('@/pages/score/score.vue')
var Personal = function Personal() {
  return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 384));
};
var PersonalSetup = function PersonalSetup() {
  return __webpack_require__.e/* import() */(24).then(__webpack_require__.bind(null, 385));
};
var Release = function Release() {
  return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, 387));
};
var Account = function Account() {
  return __webpack_require__.e/* import() */(25).then(__webpack_require__.bind(null, 363));
};
var NoteList = function NoteList() {
  return __webpack_require__.e/* import() */(20).then(__webpack_require__.bind(null, 382));
};
var ModifyTel = function ModifyTel() {
  return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, 381));
};
var ModifyPwd = function ModifyPwd() {
  return __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, 380));
};
var ModifyInfo = function ModifyInfo() {
  return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 379));
};

var Funs = function Funs() {
  return __webpack_require__.e/* import() */(21).then(__webpack_require__.bind(null, 374));
};
var Follow = function Follow() {
  return __webpack_require__.e/* import() */(22).then(__webpack_require__.bind(null, 372));
};
var User = function User() {
  return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 391));
};

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  // routes配置最好加上name属性，用于参数传递
  routes: [{
    path: '',
    redirect: '/home'
  }, {
    path: '/home',
    name: 'home',
    component: Home
  }, {
    path: '/match',
    name: 'match',
    component: Match
  }, {
    path: '/matchDetail',
    component: MatchDetail
  }, {
    path: '/findDetail',
    component: FindDetail
  }, {
    path: '/equip',
    component: Equip
  }, {
    path: '/equipList',
    component: EquipList
  }, {
    path: '/equipDetail',
    component: EquipDetail
  }, {
    path: '/collect',
    component: Collect
  }, {
    path: '/collectText',
    component: CollectText
  }, {
    path: '/signUp',
    component: SignUp
  }, {
    path: '/addSignup',
    name: 'addSignup',
    component: AddSignup
  }, {
    path: '/signupList',
    component: SignupList
  }, {
    path: '/pay',
    component: Pay
  }, {
    path: '/login',
    component: Login
  }, {
    path: '/forgot',
    component: Forgot
  }, {
    path: '/register',
    component: Register
  },
  // {
  //   path: '/loginNext',
  //   component: LoginNext
  // },
  {
    path: '/setPwd',
    component: SetPwd
  }, {
    path: '/deal',
    component: Deal
  },
  // {
  //   path: '/quiz',
  //   component: Quiz
  // },

  // {
  //   path: '/analysis',
  //   component: Analysis
  // },
  // {
  //   path: '/score',
  //   component: Score
  // },
  {
    path: '/personal',
    component: Personal
  }, {
    path: '/personalSetup',
    component: PersonalSetup
  }, {
    path: '/release',
    component: Release
  }, {
    path: '/account',
    component: Account
  }, {
    path: '/noteList',
    component: NoteList
  }, {
    path: '/modifyTel',
    component: ModifyTel
  }, {
    path: '/modifyPwd',
    component: ModifyPwd
  }, {
    path: '/modifyInfo',
    component: ModifyInfo
  }, {
    path: '/funs',
    name: 'Funs',
    component: Funs
  }, {
    path: '/follows',
    name: 'Follow',
    component: Follow
  }, {
    path: '/user/:id',
    name: 'User',
    component: User
  }],
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  }
});

//白名单
var whiteList = ['/home', '/equip', '/login', '/deal', '/forgot', '/collectText', '/register', '/setPwd'];
// 路由拦截
router.beforeEach(function (to, from, next) {
  // 没有匹配成功的路由，跳转到index页面,to.matched.length一级路由返回1，二级路由返回2，以此类推
  // if (to.matched.length >= 1) {
  //   next()
  // } else {
  //   next({path: '/news'})
  // }

  if (!__WEBPACK_IMPORTED_MODULE_2__store_store__["a" /* default */].state.token && localStorage.getItem('token')) {
    __WEBPACK_IMPORTED_MODULE_2__store_store__["a" /* default */].commit('SETTOKEN', localStorage.getItem('token'));
    __WEBPACK_IMPORTED_MODULE_2__store_store__["a" /* default */].commit('SETUSERINFO', JSON.parse(localStorage.getItem('userinfo')));
  }

  if (__WEBPACK_IMPORTED_MODULE_2__store_store__["a" /* default */].state.token || whiteList.indexOf(to.path) > -1) {
    next();
  } else {
    next({ path: '/login' });
  }
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ 138:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 139:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 143:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(350)
}
var Component = __webpack_require__(144)(
  /* script */
  __webpack_require__(147),
  /* template */
  __webpack_require__(356),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 147:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  methods: {
    onSwipeRight: function onSwipeRight() {
      this.$router.go(-1);
    }
  },
  created: function created() {
    if (!this.$store.state.token && localStorage.getItem('token')) {
      this.$store.dispatch('setToken', localStorage.getItem('token'));
    }
  }
});

/***/ }),

/***/ 148:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mint_ui__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mint_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_mint_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mint_ui_lib_style_css__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mint_ui_lib_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_mint_ui_lib_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_lazyload__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_store__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_infinite_scroll__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_infinite_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_infinite_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_directive_touch__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_directive_touch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_directive_touch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_awesome_mui__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_awesome_mui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_awesome_mui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_js_editor_js__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_common_stylus_index_styl__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_common_stylus_index_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_common_stylus_index_styl__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.






// import fastclick from 'fastclick'






__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_vue_awesome_mui___default.a);


__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__common_js_editor_js__["a" /* default */])();

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_vue_directive_touch___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_vue_infinite_scroll___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_mint_ui___default.a);

// 将fastclick挂载到body上，解决所有元素的点击事件的300ms延迟问题
// fastclick.attach(document.body)

// 延迟加载
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_vue_lazyload__["default"], {
  preLoad: 1.3,
  error: __webpack_require__(68),
  loading: __webpack_require__(68),
  attempt: 1
});

// 导入默认样式


__WEBPACK_IMPORTED_MODULE_1_vue__["default"].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({
  el: '#app',
  store: __WEBPACK_IMPORTED_MODULE_7__store_store__["a" /* default */],
  router: __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_4__App___default.a);
  }
});

/***/ }),

/***/ 149:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setToken", function() { return setToken; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setUserId", function() { return setUserId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setUserinfo", function() { return setUserinfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeData", function() { return removeData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "signUpList", function() { return signUpList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "clearSignUpList", function() { return clearSignUpList; });
var setToken = function setToken(_ref, value) {
  var commit = _ref.commit;

  commit('SETTOKEN', value);
};
var setUserId = function setUserId(_ref2, value) {
  var commit = _ref2.commit;

  commit('SETUSERID', value);
};
var setUserinfo = function setUserinfo(_ref3, value) {
  var commit = _ref3.commit;

  commit('SETUSERINFO', value);
};
var removeData = function removeData(_ref4) {
  var commit = _ref4.commit;

  commit('REMOVEDATA');
};
var signUpList = function signUpList(_ref5, value) {
  var commit = _ref5.commit;

  commit('SIGNUPLIST', value);
};
var clearSignUpList = function clearSignUpList(_ref6) {
  var commit = _ref6.commit;

  commit('CLEARSIGNUPLIST');
};

/***/ }),

/***/ 350:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 356:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('transition', [_c('router-view')], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 68:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/lazyload.bb3f9b3.png";

/***/ }),

/***/ 69:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(149);




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

// 应用初始状态
var state = {
  token: null,
  userid: null,
  userinfo: null,
  signUpList: []

  // 定义所需的 mutations
};var mutations = {
  SETTOKEN: function SETTOKEN(state, value) {
    state.token = value;
  },
  SETUSERID: function SETUSERID(state, value) {
    state.userid = value;
  },
  SETUSERINFO: function SETUSERINFO(state, value) {
    state.userinfo = value;
  },
  REMOVEDATA: function REMOVEDATA(state) {
    state.token = null;
    state.userid = null;
    state.userinfo = null;
    localStorage.setItem('userinfo', '');
  },
  SIGNUPLIST: function SIGNUPLIST(state, value) {
    state.signUpList = value;
  },
  CLEARSIGNUPLIST: function CLEARSIGNUPLIST(state) {
    state.signUpList = [];
  }
};

// 创建 store 实例
/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  actions: __WEBPACK_IMPORTED_MODULE_2__actions__,
  state: state,
  mutations: mutations
}));

/***/ })

},[148]);


// WEBPACK FOOTER //
// static/js/app.6a453b9adc88324b873d.js